import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { DeleteConfirmationDialog } from '../common/DeleteConfirmationDialog';

interface SettingsMenuProps {
    active: boolean;
    kValue: number;
    onToggleActive: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKValueChange: (value: number) => void;
    onDelete: () => void;
}

export const SettingsMenu: React.FC<SettingsMenuProps> = ({
    active,
    kValue,
    onToggleActive,
    onKValueChange,
    onDelete,
}): JSX.Element => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [localK, setLocalK] = useState<number>(kValue);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (): void => {
        setAnchorEl(null);
    };

    const handleKValueChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = Number(event.target.value);

        setLocalK(value);
        onKValueChange(value);
    };
    const handleDelete = (): void => {
        setDeleteDialogOpen(true);
    };
    const handleDeleteConfirm = (): void => {
        setDeleteDialogOpen(false);
        handleClose();
        onDelete();
    };
    const handleDeleteCancel = (): void => {
        setDeleteDialogOpen(false);
    };

    return (
        <>
            <Button
                aria-label="Settings"
                color="secondary"
                startIcon={<SettingsIcon />}
                variant="outlined"
                onClick={handleOpen}
            >
                Settings
            </Button>
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                MenuListProps={{ sx: { minWidth: 260 } }}
                open={open}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={handleClose}
            >
                <MenuItem disableRipple disableTouchRipple sx={{ cursor: 'default', py: 2 }}>
                    <ListItemText>K Value:</ListItemText>
                    <TextField
                        inputProps={{ min: 1, max: 100, style: { width: 60 } }}
                        size="small"
                        sx={{ ml: 2 }}
                        type="number"
                        value={localK}
                        onChange={handleKValueChange}
                    />
                </MenuItem>
                <MenuItem disableRipple disableTouchRipple sx={{ cursor: 'default', py: 2 }}>
                    <ListItemText>Enabled:</ListItemText>
                    <Switch
                        checked={active}
                        color="primary"
                        edge="end"
                        inputProps={{ 'aria-label': 'Enable/Disable' }}
                        sx={{ ml: 2 }}
                        onChange={onToggleActive}
                    />
                </MenuItem>
                <MenuItem sx={{ py: 2 }} onClick={handleDelete}>
                    <ListItemIcon><DeleteIcon color="error" fontSize="small" /></ListItemIcon>
                    <ListItemText primaryTypographyProps={{ color: 'error' }}>Delete Test</ListItemText>
                </MenuItem>
            </Menu>
            <DeleteConfirmationDialog
                description="Are you sure you want to delete this test definition? This action cannot be undone."
                open={deleteDialogOpen}
                title="Delete Test"
                onCancel={handleDeleteCancel}
                onDelete={handleDeleteConfirm}
            />
        </>
    );
};
